import {
    // Assignment as AssignmentIcon,
    Dashboard as DashboardIcon,
    EventNoteTwoTone as EventNoteTwoToneIcon,
    ExitToApp as ExitToAppIcon,
    GroupOutlined as GroupOutlinedIcon,
    HomeTwoTone as HomeTwoToneIcon,
    Portrait as PortraitIcon,
    School as SchoolIcon,
    Settings as SettingsIcon,
    SettingsTwoTone as SettingsTwoToneIcon,
    MenuBookTwoTone as MenuBookTwoToneIcon,
    ModeComment as ModeCommentIcon
} from '@material-ui/icons';

// Super Admin = 1
// School Admin = 2
// Subject Coordinator = 3
// Faculty = 4
// Student = 5

export const masterNavItems = [
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Dashboard",
                url: "/dashboard",
                icon: <DashboardIcon />
            },
            {
                name: "Roles",
                url: "/roles",
                icon: <PortraitIcon />
            },
            {
                name: "System Users",
                url: "/system-users",
                icon: <GroupOutlinedIcon />
            },
            {
                name: "Manage Schools",
                url: "/manage-schools",
                icon: <SchoolIcon />
            },
            {
                name: "Settings",
                url: "/master-settings",
                icon: <SettingsIcon />
            },
            {
                name: "Logout",
                url: "/logout",
                icon: <ExitToAppIcon />
            },
        ]
    }
];

export const schoolAdminNavItems = [
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Dashboard",
                url: "/dashboard",
                icon: <DashboardIcon />
            },
            {
                name: "System Users",
                url: "/system-users",
                icon: <GroupOutlinedIcon />
            },
            {
                name: "Students",
                url: "/students",
                icon: <SchoolIcon />
            },
            {
                name: "Logout",
                url: "/logout",
                icon: <ExitToAppIcon />
            },
        ]
    }
];

export const subjectCoordinatorNavItems = [
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Announcements",
                url: "/announcements",
                icon: <ModeCommentIcon />
            },
            {
                name: "Classes",
                url: "/dashboard",
                icon: <HomeTwoToneIcon />
            },
            {
                name: "Calendar",
                url: "/calendar",
                icon: <EventNoteTwoToneIcon />
            }
        ]
    },
    {
        name: "",
        subHeader: "Teaching",
        subItems: [
            {
                name: "E-Books",
                url: "/e-books",
                icon: <MenuBookTwoToneIcon />
            }
        ]
    },
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Settings",
                subHeader: "",
                url: "/my-account",
                icon: <SettingsTwoToneIcon />,
                subItems: []
            },
            {
                name: "Logout",
                url: "/logout",
                icon: <ExitToAppIcon />
            },
        ]
    }
];

export const facultyNavItems = [
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Announcements",
                url: "/announcements",
                icon: <ModeCommentIcon />
            },
            {
                name: "Classes",
                url: "/dashboard",
                icon: <HomeTwoToneIcon />
            },
            {
                name: "Calendar",
                url: "/calendar",
                icon: <EventNoteTwoToneIcon />
            },
            {
                name: "Examinations",
                url: "/examinations",
                icon: <EventNoteTwoToneIcon />,
                badge: "beta"
            }
        ]
    },
    {
        name: "",
        subHeader: "Teaching",
        subItems: [
            {
                name: "E-Books",
                url: "/e-books",
                icon: <MenuBookTwoToneIcon />
            }
        ]
    },
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Settings",
                subHeader: "",
                url: "/my-account",
                icon: <SettingsTwoToneIcon />,
                subItems: []
            },
            {
                name: "Logout",
                url: "/logout",
                icon: <ExitToAppIcon />
            },
        ]
    }
];

export const studentNavItems = [
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Announcements",
                url: "/announcements",
                icon: <ModeCommentIcon />
            },
            {
                name: "Classes",
                url: "/dashboard",
                icon: <HomeTwoToneIcon />
            },
            {
                name: "Calendar",
                url: "/calendar",
                icon: <EventNoteTwoToneIcon />
            },
            {
                name: "E-Books",
                url: "/e-books",
                icon: <MenuBookTwoToneIcon />
            },
            {
                name: "Examinations",
                url: "/examinations",
                icon: <EventNoteTwoToneIcon />,
                badge: "beta"
            }
        ]
    },
    {
        name: "",
        subHeader: "",
        subItems: [
            {
                name: "Settings",
                subHeader: "",
                url: "/my-account",
                icon: <SettingsTwoToneIcon />,
                subItems: []
            },
            {
                name: "Logout",
                url: "/logout",
                icon: <ExitToAppIcon />
            },
        ]
    }
];

// export default {
//     masterNavItems,
//     facultyNavItems
// }